import {
   PatientContinuouslyUsedMedicine,
   PatientContinuouslyUsedMedicineCreateCommand,
   PatientMedicine,
} from '@dreryk/egabinet-prescription-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

export const useCreateContinuouslyUsedMedicine = (
   patientId: number,
   medicineId: PatientMedicine['medicine']['id'],
   onMedicineAdded: (id: PatientMedicine['patientContinuouslyUsedMedicineId'] | undefined) => void
): UseCqrsCommandResult<PatientContinuouslyUsedMedicine> => {
   return useCqrsCommand(
      () => {
         const command = new PatientContinuouslyUsedMedicineCreateCommand();
         command.medicineId = medicineId;
         command.patientId = patientId;
         return command;
      },
      {
         onSuccess: (result) => {
            dispatchSnackbarPositiveEvent(
               translationKeys.medicine.continuouslyUsedMedicine.successfullyCreatedContinuouslyUsedMedicine
            );
            onMedicineAdded(result.id);
         },
      }
   );
};
